import {
  hmplusGlobalReleaseConstants,
  addHMPLUSGlobalReleaseConstants,
  editHMPLUSGlobalReleaseConstants,
} from "../_redux-constants";
import { hmplusGlobalReleaseService } from "../../_services";

function getHMPLUSGlobalRelease() {
  function getHMPLUSGlobalReleaseLoad() {
    return { type: hmplusGlobalReleaseConstants.HMPLUS_GLOBAL_RELEASE_LOADING };
  }
  function getHMPLUSGlobalReleaseSuccess(data) {
    return {
      type: hmplusGlobalReleaseConstants.HMPLUS_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function getHMPLUSGlobalReleaseFailure(error) {
    return {
      type: hmplusGlobalReleaseConstants.HMPLUS_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getHMPLUSGlobalReleaseLoad());
    return hmplusGlobalReleaseService.getHMPLUSGlobalRelease().then(
      (data) => {
        dispatch(getHMPLUSGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(getHMPLUSGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function addHMPLUSGlobalRelease(formData) {
  function addHMPLUSGlobalReleaseLoad() {
    return {
      type: addHMPLUSGlobalReleaseConstants.ADD_HMPLUS_GLOBAL_RELEASE_LOADING,
    };
  }
  function addHMPLUSGlobalReleaseSuccess(data) {
    return {
      type: addHMPLUSGlobalReleaseConstants.ADD_HMPLUS_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function addHMPLUSGlobalReleaseFailure(error) {
    return {
      type: addHMPLUSGlobalReleaseConstants.ADD_HMPLUS_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addHMPLUSGlobalReleaseLoad());
    return hmplusGlobalReleaseService.addHMPLUSGlobalRelease(formData).then(
      (data) => {
        dispatch(addHMPLUSGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(addHMPLUSGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function editHMPLUSGlobalRelease(formData) {
  function editHMPLUSGlobalReleaseLoad() {
    return {
      type: editHMPLUSGlobalReleaseConstants.EDIT_HMPLUS_GLOBAL_RELEASE_LOADING,
    };
  }
  function editHMPLUSGlobalReleaseSuccess(data) {
    return {
      type: editHMPLUSGlobalReleaseConstants.EDIT_HMPLUS_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function editHMPLUSGlobalReleaseFailure(error) {
    return {
      type: editHMPLUSGlobalReleaseConstants.EDIT_HMPLUS_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editHMPLUSGlobalReleaseLoad());
    return hmplusGlobalReleaseService.editHMPLUSGlobalRelease(formData).then(
      (data) => {
        dispatch(editHMPLUSGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(editHMPLUSGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

export const hmplusGlobalReleaseActions = {
  getHMPLUSGlobalRelease,
  addHMPLUSGlobalRelease,
  editHMPLUSGlobalRelease,
};
